var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uc4b32",attrs:{"id":"defaultId1"}},_vm._l((100),function(item){return _c('div',{staticClass:"u376b3",attrs:{"id":"gee6e0"}},[_vm._v(_vm._s(_vm.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }